import { useContext } from "react"
import { SettingsContext } from "minimals-template/components/contexts/SettingsContext"

// ----------------------------------------------------------------------

const useSettings = () => useContext(SettingsContext)

export default useSettings
